// src/pages/StaffRoles/components/RoleList.jsx
import React from "react";
import RoleCard from "./RoleCard";
import Empty from "components/Empty";
import rolesImg from "assets/images/roles_group.svg";

const RoleList = ({
  roles,
  onEdit,
  onDelete,
  onMarkDefault,
  t,
  showMarkDefault = true,
  showEditDelete = true,
}) => {
  if (!roles || roles.length === 0) {
    return (
      <Empty
        Image={rolesImg}
        Message={t("accountOwner.emptyStaffRolesMessage")}
      />
    );
  }

  return (
    <>
      {roles.map((role) => (
        <RoleCard
          key={role.id}
          role={role}
          onEdit={onEdit}
          onDelete={onDelete}
          onMarkDefault={onMarkDefault}
          t={t}
          showMarkDefault={showMarkDefault}
          showEditDelete={showEditDelete}
        />
      ))}
    </>
  );
};

export default RoleList;
